// 生效中的條件（頂部列下方）：搜尋、類型、日期範圍；手機另外列出平台（桌面的平台在常用平台膠囊上）。
// 每個膠囊可以單獨移除，兩個以上時提供「清除全部」。
import type { GenreKey, PlatformKey } from '@dayone/core/dictionaries';
import { clearFilter, type FilterState, toggleGenre, togglePlatform } from '../../filters/state.ts';
import type { Update } from '../../filters/useFilterState.ts';
import { t } from '../../i18n/zh-TW.ts';
import { ICON, X } from '../../ui/icons/index.ts';

interface Chip {
  key: string;
  label: string;
  remove: (s: FilterState) => FilterState;
}

export function activeChips(state: FilterState, withPlatforms: boolean): Chip[] {
  const chips: Chip[] = [];
  if (state.q)
    chips.push({ key: 'q', label: t.filters.searchChip(state.q), remove: (s) => ({ ...s, q: '', page: 1 }) });
  if (withPlatforms) {
    for (const p of state.platforms) {
      chips.push({
        key: `pf:${p}`,
        label: t.platforms[p as PlatformKey],
        remove: (s) => ({ ...s, platforms: togglePlatform(s.platforms, p), page: 1 }),
      });
    }
  }
  for (const g of state.genres) {
    chips.push({
      key: `gn:${g}`,
      label: t.genres[g as GenreKey],
      remove: (s) => ({ ...s, genres: toggleGenre(s.genres, g), page: 1 }),
    });
  }
  if (state.from || state.to) {
    chips.push({
      key: 'date',
      label: t.filters.dateRange(state.from ?? '', state.to ?? ''),
      remove: (s) => clearFilter(s, 'date'),
    });
  }
  return chips;
}

export function ActiveFilters({
  state,
  update,
  withPlatforms,
}: {
  state: FilterState;
  update: (u: Update) => void;
  withPlatforms: boolean;
}) {
  const chips = activeChips(state, withPlatforms);
  if (chips.length === 0) return null;
  return (
    <ul className="active-filters" aria-label={t.filters.panel}>
      {chips.map((c) => (
        <li key={c.key}>
          <button type="button" className="pill pill-on active-chip" onClick={() => update(c.remove)}>
            <span>{c.label}</span>
            <X {...ICON} aria-hidden="true" />
            <span className="sr-only">{t.filters.remove(c.label)}</span>
          </button>
        </li>
      ))}
      {chips.length > 1 && (
        <li>
          <button type="button" className="link-button" onClick={() => update((s) => clearFilter(s, 'all'))}>
            {t.list.clearAll}
          </button>
        </li>
      )}
    </ul>
  );
}
